import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'userDateTime'
})
export class UserDateTimePipe implements PipeTransform {
    transform(value: any) {
        if (!value) return null;

        let dateTime = new Date(value);

        return new Intl.DateTimeFormat('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        }).format(dateTime)
    }
}